import React, { useEffect, useState } from "react";
import logo from "../../assets/images/logo-win.svg";
import highmarkLogo from "../../assets/images/highmark/ffb-logo.jpg";

import { useTranslation } from 'react-i18next';
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useSelector } from 'react-redux';
// AppWhyHere Images
import I_want_family_building_support1 from '../../assets/images/welcome/AppWhyHere/I_want_family_building_support_1.jpg';
import I_want_family_building_support2 from '../../assets/images/welcome/AppWhyHere/I_want_family_building_support_2.jpg';
import I_want_family_building_support3 from '../../assets/images/welcome/AppWhyHere/I_want_family_building_support_3.jpg';
import I_want_perimenopause_or_menopause_support1 from '../../assets/images/welcome/AppWhyHere/I_want_perimenopause_or_menopause_support_1.jpg';
import I_want_perimenopause_or_menopause_support2 from '../../assets/images/welcome/AppWhyHere/I_want_perimenopause_or_menopause_support_2.jpg';
import I_want_perimenopause_or_menopause_support3 from '../../assets/images/welcome/AppWhyHere/I_want_perimenopause_or_menopause_support_3.jpg';
import I_want_andropause_support1 from '../../assets/images/welcome/AppWhyHere/I_want_andropause_low_Testosterone_support_1.jpg';
import I_want_andropause_support2 from '../../assets/images/welcome/AppWhyHere/I_want_andropause_low_Testosterone_support_2.jpg';
import I_want_andropause_support3 from '../../assets/images/welcome/AppWhyHere/I_want_andropause_low_Testosterone_support_3.jpg';
import I_want_pregnancy_support1 from '../../assets/images/welcome/AppWhyHere/I_want_pregnancy_support_1.jpg';
import I_want_pregnancy_support2 from '../../assets/images/welcome/AppWhyHere/I_want_pregnancy_support_2.jpg';
import I_want_pregnancy_support3 from '../../assets/images/welcome/AppWhyHere/I_want_pregnancy_support_3.jpg';
import I_want_caregiving_support1 from '../../assets/images/welcome/AppWhyHere/I_want_caregiving_support_1.jpg';
import I_want_caregiving_support2 from '../../assets/images/welcome/AppWhyHere/I_want_caregiving_support_2.jpg';
import I_want_caregiving_support3 from '../../assets/images/welcome/AppWhyHere/I_want_caregiving_support_3.jpg';
import I_want_parenting_and_child_development_support1 from '../../assets/images/welcome/AppWhyHere/I_want_parenting_and_child_development_support_1.jpg';
import I_want_parenting_and_child_development_support2 from '../../assets/images/welcome/AppWhyHere/I_want_parenting_and_child_development_support_2.jpg';
import I_want_parenting_and_child_development_support3 from '../../assets/images/welcome/AppWhyHere/I_want_parenting_and_child_development_support_3.jpg';
import I_want_womens_health_support1 from '../../assets/images/welcome/AppWhyHere/I_want_womens_health_support_1.jpg';
import I_want_womens_health_support2 from '../../assets/images/welcome/AppWhyHere/I_want_womens_health_support_2.jpg';
import I_want_womens_health_support3 from '../../assets/images/welcome/AppWhyHere/I_want_womens_health_support_3.jpg';

const WelcomeForm = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const registrationData = useSelector((state) => state.registration.registrationData);

    const ssoData = useSelector((state) => state.sso.ssoUserData);
      const isHighmarkPortal = ssoData?.Portal === "Highmark";

    const [AppWhyHere, setAppWhyHere] = useState('');
    const [stage, setStage] = useState(1);  // Manage multi-stage form
    const [descriptions, setDescriptions] = useState({
        1: "",
        2: "",
        3: "",
    });
    const HIGHMARK_TITLES = {
  1: "Welcome!",
  2: "Explore your benefits.",
  3: "What happens now?"
};
    const HIGHMARK_LABELS = {
  one: "We're so glad you're here and can't wait to support you through your family-building and family well-being journey.",
  two: "Want to know everything your benefits cover? Simply tap the Benefits tab on your home page to learn more.",
  three: "Every journey begins with a Nurse Care Advocate appointment—which you can book right now.",
};

    useEffect(() => {
        const options = registrationData.WhyHere
            ? registrationData.WhyHere.split(',').map((option) => option.trim())
            : [];
        const selectedOption = options.includes("I want family-building support")
            ? "I want family-building support"
            : options[0] || '';

        setAppWhyHere(selectedOption);

        // Set descriptions based on the selected service (AppWhyHere)
        switch (selectedOption) {
            case "I want family-building support":
                if (isHighmarkPortal) {
        setDescriptions({
            1: HIGHMARK_LABELS.one,
            2: HIGHMARK_LABELS.two,
            3: HIGHMARK_LABELS.three
        });
    } else {
        setDescriptions({
            1: "We're so glad you're here and can't wait to take the first step of your family-building journey together.",
            2: t("welcomformtitletwo"),
            3: t("welcomformtitlethree")
        });
    }
                break;
            case "I want perimenopause or menopause support":
                if (isHighmarkPortal) {
        setDescriptions({
            1: HIGHMARK_LABELS.one,
            2: HIGHMARK_LABELS.two,
            3: HIGHMARK_LABELS.three
        });
    } else {
        setDescriptions({
            1: "We're so glad you're here and we look forward to supporting you as you navigate the path to healthy aging.",
            2: t("welcomformtitletwo"),
            3: t("welcomformtitlethree")
        });
    }
                break;
            case "I want andropause (low Testosterone) support":
                if (isHighmarkPortal) {
        setDescriptions({
            1: HIGHMARK_LABELS.one,
            2: HIGHMARK_LABELS.two,
            3: HIGHMARK_LABELS.three
        });
    } else {
        setDescriptions({
            1:"We're so glad you're here and we look forward to supporting you as you navigate the path to healthy aging.",
            2: t("welcomformtitletwo"),
            3: t("welcomformtitlethree")
        });
    }
                break;
            case "I want pregnancy support":
                if (isHighmarkPortal) {
        setDescriptions({
            1: HIGHMARK_LABELS.one,
            2: HIGHMARK_LABELS.two,
            3: HIGHMARK_LABELS.three
        });
    } else {
        setDescriptions({
            1: "Preparing for parenthood is special- and overwhelming. That's why we're here to support you through pregnancy and your first days as a parent.",
            2: t("welcomformtitletwo"),
            3: t("welcomformtitlethree")
        });
    }
                break;
            case "I want caregiving support":
                if (isHighmarkPortal) {
        setDescriptions({
            1: HIGHMARK_LABELS.one,
            2: HIGHMARK_LABELS.two,
            3: HIGHMARK_LABELS.three
        });
    } else {
        setDescriptions({
            1: "We're so glad you're here. We know caring for children or adult or senior loved ones can take a toll, that's why we're here to care for you.",
            2: t("welcomformtitletwo"),
            3: t("welcomformtitlethree")
        });
    }
                break;
            case "I want parenting and child development support":
                if (isHighmarkPortal) {
        setDescriptions({
            1: HIGHMARK_LABELS.one,
            2: HIGHMARK_LABELS.two,
            3: HIGHMARK_LABELS.three
        });
    } else {
        setDescriptions({
            1: "We're so glad you're here and can't wait to support you through tantrums, sleep regressions, return-to-work, and more.",
            2: t("welcomformtitletwo"),
            3: t("welcomformtitlethree")
        });
    }
                break;
            case "I want women's health support":
                if (isHighmarkPortal) {
        setDescriptions({
            1: HIGHMARK_LABELS.one,
            2: HIGHMARK_LABELS.two,
            3: HIGHMARK_LABELS.three
        });
    } else {
        setDescriptions({
            1: "We're so glad you're here. Whatever your women's healthcase needs--breast and pelvic floor health to behavioral health support and more--we're here for you.",
            2: t("welcomformtitletwo"),
            3: t("welcomformtitlethree")
        });
    }
                break;
            default:
                break;
        }
    }, [registrationData.WhyHere]);

    const handleClick = () => {
        navigate("/book-appointment", { state: { fromWelcomeForm: true } });
    };

    const nextStage = () => {
        if (stage < 3) {
            setStage(stage + 1);
        }
    };

    const backStage = () => {
        if (stage > 1) {
            setStage(stage - 1);
        }
    };
    const titles = isHighmarkPortal
  ? HIGHMARK_TITLES
  : {
      1: t("welcometowin"),
      2: t("exploreyourwinbenefit"),
      3: t("whathappensnow"),
    };
    // If Highmark portal, always show only the last step
    useEffect(() => {
        if (isHighmarkPortal) {
            setStage(3);
        }
    }, [isHighmarkPortal]);

    const getImageSet = (AppWhyHere) => {
        switch (AppWhyHere) {
            case "I want family-building support":
                return [I_want_family_building_support1, I_want_family_building_support2, I_want_family_building_support3];
            case "I want perimenopause or menopause support":
                return [I_want_perimenopause_or_menopause_support1, I_want_perimenopause_or_menopause_support2, I_want_perimenopause_or_menopause_support3];
            case "I want andropause (low Testosterone) support":
                return [I_want_andropause_support1, I_want_andropause_support2, I_want_andropause_support3];
            case "I want pregnancy support":
                return [I_want_pregnancy_support1, I_want_pregnancy_support2, I_want_pregnancy_support3];
            case "I want caregiving support":
                return [I_want_caregiving_support1, I_want_caregiving_support2, I_want_caregiving_support3];
            case "I want parenting and child development support":
                return [I_want_parenting_and_child_development_support1, I_want_parenting_and_child_development_support2, I_want_parenting_and_child_development_support3];
            case "I want women's health support":
                return [I_want_womens_health_support1, I_want_womens_health_support2, I_want_womens_health_support3];
            default:
                return [];
        }
    };

    const imageSet = getImageSet(AppWhyHere);

    const imageSe = [
  I_want_parenting_and_child_development_support1,
  I_want_family_building_support2,
  I_want_family_building_support3
];

    return (
        <>
            <header>
                <nav className="navbar navbar-expand-lg container-fixed">
                    <a className="navbar-brand" href="#">
                        {isHighmarkPortal ? 
                            <img src={highmarkLogo} alt="Logo" className="logo brand-logo" />
                        : 
                            <img src={logo} alt="Logo" className="logo brand-logo" />
                        }
                    </a>
                </nav>
            </header>

            <div className="registration-block-main">
                <div className="registration-image-wrapper welcome-page-image-wrapper">
                    {imageSe[stage - 1] && (
                        <img
                            src={imageSe[stage - 1]}
                            alt={`Stage ${stage}`}
                            className="registration-image"
                        />
                    )}
                </div>

                <div className="registration-form-main">
                    <div className="registration-form">
                        <h3 className="page-heading-bold">{titles[stage]}</h3>
                        <p>{descriptions[stage]}</p>
                        <div className="mt-5 d-flex">
                            {stage > 1 && !isHighmarkPortal && (
                                <button onClick={backStage} className="win-btn-secondary  mobile-view me-3">{t('back')}</button>
                            )}
                            {stage < 3 ? (
                                <button 
                                    onClick={nextStage} 
                                    className={stage === 1 ? "win-btn-primary mobile-view" : "win-btn-primary mobile-view me-3"}
                                >
                                    {t('Next')}
                                </button>
                            ) : (
                                <button 
                                    type="submit" 
                                    onClick={handleClick} 
                                    className="win-btn-primary mobile-view"
                                >
                                    {t('bookappointment')}
                                </button>
                            )}
                        </div>

                        {stage === 3 && (
  <div className="mt-5">
    <Link to="/home" className="win-btn-skip">{t("skip")}</Link>
  </div>
)}
                    </div>
                </div>
            </div>
        </>
    );
};

export default WelcomeForm;
